/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
import type { DurationTypeValue, InsightType } from '../model/types';

export interface OpportunitiesRoomQueryFilters {
  favoritesOnly?: boolean;
  dateStart?: string;
  dateEnd?: string;
  topic?: string;
  sortBy?: 'created_at';
  sortOrder?: 'ASC' | 'DESC';
  durationTypes?: DurationTypeValue[];
  insightType?: InsightType;
  market?: string;
  audience?: string;
  search?: string;
}

export const OPPORTUNITIES_QUERY_KEYS = {
  all: ['opportunities'] as const,

  byWorkspace: (workspaceId: string | null) =>
    [...OPPORTUNITIES_QUERY_KEYS.all, workspaceId] as const,

  allByWorkspace: (workspaceId: string | null) =>
    [...OPPORTUNITIES_QUERY_KEYS.byWorkspace(workspaceId), 'all'] as const,

  favoritesByWorkspace: (workspaceId: string | null) =>
    [...OPPORTUNITIES_QUERY_KEYS.byWorkspace(workspaceId), 'favorites'] as const,

  room: (workspaceId: string | null, filters?: OpportunitiesRoomQueryFilters) =>
    [...OPPORTUNITIES_QUERY_KEYS.byWorkspace(workspaceId), 'room', filters] as const,

  roomKpi: (workspaceId: string | null, since?: string) =>
    [...OPPORTUNITIES_QUERY_KEYS.byWorkspace(workspaceId), 'room', 'kpi', since ?? null] as const,
} as const;
